import { Button } from 'shared/ui/Button';
import { Modal } from 'shared/ui/Modal';

type Props = {
  onOpenChange: (open: boolean) => void;
  open: boolean;
  redirectPath?: string;
};

export const MaintenanceModal = ({ onOpenChange, open }: Props) => {
  return (
    <Modal onOpenChange={onOpenChange} open={open}>
      <Modal.Content className="w-full !max-w-screen-xs 3xl:!max-w-xl" contentClassName="sm:p-6">
        <div className="flex flex-col justify-between gap-2 rounded-lg bg-white">
          <span className="text-2xl font-bold">Under Maintenance</span>
          <span className="text-lg font-light">
            This feature is undergoing maintenance in preparation for Nesa’s upcoming phase. Stay tuned!
          </span>
          <Button className="mt-5 w-full" onClick={() => onOpenChange(false)}>
            Okay
          </Button>
        </div>
      </Modal.Content>
    </Modal>
  );
};
